const globalConstants = {
  GLOBAL_ACCOUNT_SUCCESS: 'GLOBAL_ACCOUNT_SUCCESS',
  GLOBAL_ACCOUNT_FAILURE: 'GLOBAL_ACCOUNT_FAILURE',

  GLOBAL_ACCOUNT_SELECT: 'ACCOUNT_SELECT',

  TIMEZONES_SUCCESS: 'TIMEZONES_SUCCESS',
  TIMEZONES_FAILURE: 'TIMEZONES_FAILURE',
  TIMEZONES_REQUEST: 'TIMEZONES_REQUEST',

  GLOBAL_MACHINES_REQUEST: 'GLOBAL_MACHINES_REQUEST',
  GLOBAL_MACHINES_SUCCESS: 'GLOBAL_MACHINES_SUCCESS',
  GLOBAL_MACHINES_FAILURE: 'GLOBAL_MACHINES_FAILURE',

  GLOBAL_SITES_REQUEST: 'GLOBAL_SITES_REQUEST',
  GLOBAL_SITES_SUCCESS: 'GLOBAL_SITES_SUCCESS',
  GLOBAL_SITES_FAILURE: 'GLOBAL_SITES_FAILURE',

  GLOBAL_LICENSETYPES_REQUEST: 'GLOBAL_LICENSETYPES_REQUEST',
  GLOBAL_LICENSETYPES_SUCCESS: 'GLOBAL_LICENSETYPES_SUCCESS',
  GLOBAL_LICENSETYPES_FAILURE: 'GLOBAL_LICENSETYPES_FAILURE',

  GLOBAL_MANUFACTURERS_REQUEST: 'GLOBAL_MANUFACTURERS_REQUEST',
  GLOBAL_MANUFACTURERS_SUCCESS: 'GLOBAL_MANUFACTURERS_SUCCESS',
  GLOBAL_MANUFACTURERS_FAILURE: 'GLOBAL_MANUFACTURERS_FAILURE',

  GLOBAL_KPIS_REQUEST: 'GLOBAL_KPIS_REQUEST',
  GLOBAL_KPIS_SUCCESS: 'GLOBAL_KPIS_SUCCESS',
  GLOBAL_KPIS_FAILURE: 'GLOBAL_KPIS_FAILURE',
};

export default globalConstants;
